import { render, staticRenderFns } from "./magazine-footer-panel.vue?vue&type=template&id=8bd7e002&"
var script = {}
import style0 from "./magazine-footer-panel.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports